export default __webpack_public_path__ + "static/inline-edit-do-17c55a693bb0d7b04ab2eb7c6cda3e8935fd75d41fbe97932d1e1c31294b0810.png";